// extracted by mini-css-extract-plugin
export var grayCircle = "_g0-0";
export var renderAfterShippingOptionWidgetPreviewSelected = "_g0-1";
export var selectedCircle = "_g0-2";
export var shippingOptionImage = "_g0-3";
export var shippingOptionWidgetPreview = "_g0-4";